import { OnboardingActions, paths, useOnboardingActionQry } from 'mmfintech-backend-api'
import { useHistory } from 'react-router-dom'
import usePayApplicationFee from './usePayApplicationFee'

function useOnboardingAction() {
  const history = useHistory()

  const { onboardingAction } = useOnboardingActionQry()
  const { payApplicationFee } = usePayApplicationFee()

  function startOrContinueOnboarding() {
    switch (onboardingAction) {
      case OnboardingActions.NOT_STARTED:
        history.push(paths.onboarding.selectType())
        break

      case OnboardingActions.ONBOARDING:
        history.push(paths.onboarding.continueOnboarding())
        break

      case OnboardingActions.DOCUMENTS:
        history.push(paths.onboarding.documents())
        break

      case OnboardingActions.QUESTIONNAIRE:
        history.push(paths.onboarding.questionnaireKyb())
        break

      case OnboardingActions.APPLICATION_FEE:
        payApplicationFee()
        break
    }
  }

  return {
    onboardingAction,
    startOrContinueOnboarding
  }
}

export default useOnboardingAction
